import { Component, OnInit } from '@angular/core';
import { WindowService } from '../../@core/services/window.service';
import { EquipmentDetailComponent } from './detail/equipmentdetail.component';

@Component({
    selector: 'next-equipmentlistpage',
    templateUrl: './equipment.component.html',
    styleUrls: ['./equipment.component.scss'],
    standalone: false
})
export class EquipmentComponent implements OnInit {
  constructor(private readonly windowService: WindowService) {}

  ngOnInit() {}

  viewDetail(equipment: any) {
    const { id } = equipment;
    if (!id) return;
    this.windowService.openWindow(EquipmentDetailComponent, {
      objectId: id,
      objectType: 'Equipment',
      context: { id },
      options: {
        title: 'Equipment',
      },
    });
  }
}
